import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SquareButtonComponent} from '../square-button/square-button.component';

@Component({
  selector: 'modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss'],
  imports: [CommonModule, SquareButtonComponent],

  standalone: true
})
export class ModalErrorComponent {

  @Input() showCloseButton: boolean = true;
  @Input() title!: string;
  @Input() show: boolean = false;
  @Input() closeOnBackdropClick: boolean = true;
  @Output() close = new EventEmitter<void>();

  constructor() {
  }

  onBackdropClick(): void {
    if (this.closeOnBackdropClick) {
      this.closeModal();
    }
  }

  closeModal() {
    this.close.emit();
  }
}
